import angular from 'angular';
import { castJSON } from '../../helpers';
import { DraftInvoice } from '../model/draftInvoice';
import moment from 'moment';
import DocumentService from '@/shared/services/DocumentService';
import SignalRService from '@/shared/services/SignalRService';
import userStorage from '@/shared/services/userStorage';
import guid from '@/shared/utils/guid';
import adminpulse from '@/shared/utils/adminpulse';

const columnSelectionStorageKey = 'DraftInvoiceOverviewExtraColumns';

const emptyFilters = {
  relationId: null, // Guid?
  invoiceId: null, // Guid?
  isInvoice: null, // Bool?
  searchValue: '', // string
  assistant: null, // Guid?
  assistantBackup: null, // Guid?
  responsible: null, // Guid?
  billingUser: null, // UserId
  seniorUser: null, // UserId
  relationType: [], // int[]
  legalForms: [], // int[]
  withLabels: [], // string[]
  withoutLabels: [], // string[]
  status: null, // int
  invoiceType: [], // int[]
  hasDateToNumber: null, // bool?
  ownCompanies: [], //Guid[]
  legalEntities: [], //Guid[]
  assignmentTemplateId: null, //Guid?
  invoiceStreamId: null, //Guid?
  sendInvoiceStrategy: [], // int[]
  invoiceScheduleTypes: [], //Guid[]
  relationGroups: [], //Guid[]
  crmTypes: [], //int[]
  relationHandlingLevels: [], //int[]
  paymentMethod: [], //int[]
  creditNoteReasons: [], //Guid[]
};

angular
  .module('cloudX')
  .controller('DraftInvoiceOverviewCtrl', [
    '$scope',
    '$filter',
    '$timeout',
    '$state',
    '$anchorScroll',
    'resourceFactorySvc',
    'dialogsSvc',
    'invoiceDialogsSvc',
    'flySvc',
    'dataCache',
    'invoicingSvc',
    'appUrls',
    '$http',
    '$q',
    '$translate',
    'ModalService',
    'registrationService',
    'FileSaver',
    'checkFeature',
    draftInvoiceOverviewCtrl,
  ]);

function draftInvoiceOverviewCtrl(
  $scope,
  $filter,
  $timeout,
  $state,
  $anchorScroll,
  resourceFactorySvc,
  dialogsSvc,
  invoiceDialogsSvc,
  flySvc,
  dataCache,
  invoicingSvc,
  appUrls,
  $http,
  $q,
  $translate,
  ModalService,
  registrationService,
  FileSaver,
  checkFeature,
) {
  var vm = this;
  var draftInvoiceResource = resourceFactorySvc.get('draftInvoice');
  var invoiceLineResource = resourceFactorySvc.get('invoiceLine');
  vm.sendingAll = false;
  vm.numberingAll = false;
  vm.loading = false;
  vm.bookyearInfo = {};
  vm.bookyearInfos = [];
  vm.initFilters = true;
  vm.hasFilter = false;
  vm.showAdvanceFilters = false;
  vm.selectAll = false;
  vm.initialTableParams = null;
  vm.isMasterTenant = dataCache.getArray('isMasterTenant');

  vm.filters = { ...emptyFilters };
  vm.currentFilters = null;
  vm.customer = null;
  vm.currentSearchParams = {};
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');
  vm.isMultiCompany = dataCache.getAllCompanies().length > 1;
  vm.billingInformation = {}; //Key=relationId
  vm.processingInvoicesInfo = invoicingSvc.getProcessingInvoicesInfo();

  const detailRequests = {};

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
  };

  vm.hideableColumns = [
    {
      key: 'ownCompany',
      label: $filter('translate')('OwnCompany'),
      show: false,
      hiddenBySecurity: !vm.isMultiCompany,
    },
    {
      key: 'exForfaitAmount',
      label: $filter('translate')('NotIncludedInFixedAmount'),
      show: false,
    },
    {
      key: 'originalAmount',
      label: $filter('translate')('OriginalAmount'),
      show: false,
    },
    {
      key: 'adjustedAmount',
      label: $filter('translate')('AdjustedAmount'),
      show: false,
    },
    {
      key: 'modifiedDate',
      label: $filter('translate')('ModifiedOn'),
      show: false,
    },
    {
      key: 'relationCode',
      label: $filter('translate')('RelationCode'),
      show: false,
    },
    {
      key: 'referenceYear',
      label: $filter('translate')('ReferenceYear'),
      show: false,
      hiddenBySecurity: !checkFeature('ReferenceYear'),
    },
  ];
  //Store hidden columns in object for easy use
  vm.hiddenColumns = {};

  vm.rebuildHiddenColumns = function() {
    vm.hiddenColumns = vm.hideableColumns.reduce((r, i) => {
      r[i.key] = !i.show;
      return r;
    }, {});

    vm.countVisibleExtraColumns = 0;

    Object.keys(vm.hiddenColumns).forEach(column => {
      if (!vm.hiddenColumns[column]) vm.countVisibleExtraColumns++;
    });
  };

  vm.initHiddenColumns = function() {
    const extraColumns = userStorage.getItem(columnSelectionStorageKey) || [];
    if (extraColumns.length) {
      vm.hideableColumns.forEach(col => {
        const hidden = extraColumns.indexOf(col.key) < 0;
        col.show = !hidden;
      });
    }
    vm.rebuildHiddenColumns();
  };
  vm.initHiddenColumns();

  vm.retrieveRequest = null;
  vm.retrieve = function(params) {
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();

    const requestParams = { ...(params || {}), ...(vm.filters || {}) };

    vm.hasFilter = vm.hasFilters();

    vm.currentFilters = { ...vm.filters };
    sessionStorage.setItem(
      'DraftInvoiceOverviewParams',
      JSON.stringify({
        tableParams: params,
        filters: vm.currentFilters,
        showAdvanceFilters: vm.showAdvanceFilters,
      }),
    );

    if (requestParams.page === 0) vm.reloadKPIs(requestParams);
    vm.retrieveRequest = draftInvoiceResource.query(requestParams);
    return vm.retrieveRequest.$promise.then(function(invoices) {
      vm.currentSearchParams = requestParams;

      angular.forEach(invoices, function(invoice) {
        invoice.discountActive = invoice.discountAmount > 0;
        invoice.transactionTypeActive = invoice.taxCategory !== invoice.customerTaxCategory;
        invoice.selected = vm.selectAll;
        invoice.isRemoving =
          invoice.removingStartDate &&
          moment.utc(invoice.removingStartDate) &&
          moment
            .utc(invoice.removingStartDate)
            .add(1, 'hours')
            .isAfter(moment.utc());
      });

      return invoices;
    });
  };
  const initStateParams = () => {
    if (!$state.params) return false;
    let hasParams = false;
    const {
      relation = null,
      relationId = null,
      invoiceId = null,
      invoiceStreamId = null,
    } = $state.params;

    if (relation && relation.id) {
      hasParams = true;
      vm.filters.relationId = relation.id;
      if (relation.name) {
        vm.customer = { ...relation };
      }
    } else if (relationId) {
      hasParams = true;
      vm.filters.relationId = relationId;
    }
    if (invoiceStreamId) {
      hasParams = true;
      vm.filters.invoiceStreamId = invoiceStreamId;
    }
    if (invoiceId) {
      hasParams = true;
      vm.filters.invoiceId = invoiceId;
    }

    return hasParams;
  };
  const initCustomer = relationId => {
    $http.post(appUrls.api + '/api/Relation/Names', [relationId]).then(({ data }) => {
      if (data && data.length) {
        vm.customer = data[0];
      }
    });
  };

  const bookyearInfoRequest = draftInvoiceResource.bookyearInfo(null, function(bookyearInfo) {
    vm.bookyearInfos = bookyearInfo;
    vm.bookyearInfo = bookyearInfo.reduce((o, i) => {
      o[i.companyId] = i;
      return o;
    }, {});
  });

  vm.clearFilters = function() {
    vm.filters = { ...emptyFilters };
    vm.hasFilter = false;
    vm.customer = null;
    if (vm.table) {
      vm.table.clearFilter();

      vm.table.reload();
    }
  };
  vm.updateFilter = function(value, noReload) {
    if (value) {
      vm.filters = { ...vm.filters, ...value };
    }
    if (!noReload && !angular.equals(vm.currentFilters, vm.filters)) vm.table.reload();
  };
  vm.customerFilterChanged = function(value) {
    const cust = typeof value === 'undefined' ? vm.customer : value;
    vm.updateFilter({ relationId: cust && cust.id ? cust.id : null, invoiceStreamId: null });
  };

  vm.kpiRequest = null;
  vm.reloadKPIs = function(filters) {
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.kpiRequest && vm.kpiRequest.$cancelRequest) vm.kpiRequest.$cancelRequest();
    vm.kpiRequest = draftInvoiceResource.info(filters || { ...vm.currentSearchParams }, function(
      data,
    ) {
      vm.dashboard = data;
    });
  };

  vm.discountTypes = [0, 1, 2];
  vm.minDate = moment
    .utc()
    .startOf('day')
    .add(1, 'days');

  vm.toggleDiscount = function(invoice) {
    invoice.discountActive = !invoice.discountActive;
    if (!invoice.discountActive && invoice.discountAmount > 0) {
      vm.updateInvoice(invoice, 0, 'discountAmount');
    }
  };

  const setParamsFromSessionStorage = () => {
    try {
      const sessionParams = JSON.parse(sessionStorage.getItem('DraftInvoiceOverviewParams'));

      if (sessionParams) {
        const {
          filterType = null,
          filters = {},
          tableParams = {},
          showAdvanceFilters = false,
        } = sessionParams;
        vm.filters = { ...vm.filters, ...filters };
        vm.showAdvanceFilters = showAdvanceFilters;
        if (vm.table) {
          vm.table.initializeParams(tableParams);
        } else {
          vm.initialTableParams = tableParams;
        }
      }
    } catch (error) {
      console.error('Error while setting parameters from session storage');
      console.error(error);
    }
  };

  vm.openColumnConfigDialog = function() {
    dialogsSvc
      .showCheckboxList(
        'msgSelectTableColumns',
        vm.hideableColumns
          .filter(x => !x.hiddenBySecurity)
          .map(({ key, label, show }) => ({ key, label, selected: show })),
      )
      .then(function(result) {
        if (result) {
          vm.hideableColumns.forEach(col => {
            var item = result.find(x => x.key === col.key);
            if (!item) return;
            col.show = !!item.selected;
          });
          vm.rebuildHiddenColumns();
          //Save hidden columns
          userStorage.setItem(
            columnSelectionStorageKey,
            vm.hideableColumns.filter(x => x.show).map(x => x.key),
          );
        }
      });
  };

  vm.revertSelectedInvoices = function() {
    if (vm.selectedCount() === 0) return;
    invoiceDialogsSvc.batchDeleteDraftInvoice().then(({ neverInvoice, deleteLocked }) => {
      const batchParams = vm.getBatchSelectionParams();
      const params = { ...vm.currentSearchParams };
      vm.loadingGlobalAction = true;
      $http
        .post(
          `${appUrls.api}/api/draftinvoice/revertAll`,
          {
            ...batchParams,
            neverInvoice,
            deleteLocked,
          },
          { params },
        )
        .then(
          function({ data }) {
            vm.loadingGlobalAction = false;
            vm.table.reload();
          },
          function(error) {
            vm.loadingGlobalAction = false;
            flySvc.error(error.data.code, error.data.parameters);
          },
        );
    });
  };

  vm.numberAll = function() {
    if (vm.selectedCount(true) === 0) return;
    var params = { ...vm.currentSearchParams };
    var invoicesOrCreditNotes = 3;
    var bookyearInfos = vm.bookyearInfos;
    const batchParams = vm.getBatchSelectionParams(true);

    if (vm.selectAll) {
      invoicesOrCreditNotes =
        typeof params.isInvoice === 'undefined' || params.isInvoice === null
          ? 3 // All
          : params.isInvoice
          ? 1 // Only invoices
          : 2; // Only credit notes
      if (bookyearInfos.length > 1 && vm.filters.ownCompanies.length) {
        bookyearInfos = bookyearInfos.filter(x => vm.filters.ownCompanies.includes(x.companyId));
      }
    } else {
      var selectedRows = vm.table.rows.filter(x => x.selected && x.canNumber(true));
      invoicesOrCreditNotes = selectedRows.reduce((o, r) => o | (r.isInvoice ? 1 : 2), 0);
      if (bookyearInfos.length > 1) {
        if (vm.filters.ownCompanies.length)
          bookyearInfos = bookyearInfos.filter(x => vm.filters.ownCompanies.includes(x.companyId));

        bookyearInfos = bookyearInfos.filter(x =>
          selectedRows.some(r => r.companyId === x.companyId),
        );
      }
    }

    invoiceDialogsSvc
      .numberInvoices(params, batchParams, bookyearInfos, invoicesOrCreditNotes)
      .then(function(data) {
        if (!data) return;

        var errorCount = 0;
        var succeededCount = 0;
        var positiveCreditnoteOrViceVersaCount = 0;
        var processed = false;
        var dateToNumber = null;
        data.forEach(function(result) {
          if (result.movedToProcessing) processed = true;
          if (result.dateToNumber) dateToNumber = result.dateToNumber;
          if (result.error) {
            errorCount++;
          } else if (result.isPositiveCreditnoteOrViceVersa) {
            positiveCreditnoteOrViceVersaCount++;
          } else {
            succeededCount++;
          }
          var idx = vm.table.rows.findIndex(x => x.id === result.invoiceId);
          if (idx < 0) return;
          if (result.movedToProcessing) {
            vm.table.rows.splice(idx, 1);
            return;
          }
          var invoice = vm.table.rows[idx];
          if (result.error) {
            invoice.invoiceErrors = [
              ...(invoice.invoiceErrors || []),
              { code: result.error, parameters: null },
            ];
          } else if (result.dateToNumber) {
            invoice.dateToNumber = result.dateToNumber;
          }
        });
        if (succeededCount > 0) {
          vm.reloadKPIs();
          if (processed) {
            flySvc.success('msgInvoiceCountProcessed', { count: succeededCount });
          } else {
            flySvc.success('msgInvoiceCountDateToNumber', {
              count: succeededCount,
              date: $filter('formatDate')(dateToNumber),
            });
          }
        }

        if (positiveCreditnoteOrViceVersaCount > 0) {
          flySvc.error('msgPositiveCreditNotesOrViceVersaCount', {
            count: positiveCreditnoteOrViceVersaCount,
          });
        }

        if (errorCount > 0) {
          flySvc.error('msgInvoiceCountErrors', {
            count: errorCount,
          });
        }
      });
  };

  vm.lockInvoice = invoice => {
    const locked = !invoice.locked;
    invoice.updating = true;
    $http.put(`${appUrls.api}/api/draftInvoice/Locked/${invoice.id}?locked=${locked}`).then(
      ({ data }) => {
        invoice.updating = false;
        angular.extend(invoice, data);
      },
      error => {
        invoice.updating = false;
        flySvc.error(error);
      },
    );
  };

  vm.lockAll = locked => {
    if (vm.selectedCount() === 0) return;
    var params = { ...vm.currentSearchParams, shouldLock: locked };
    vm.loadingGlobalAction = true;
    const batchParams = vm.getBatchSelectionParams(false);

    $http
      .post(
        `${appUrls.api}/api/draftinvoice/lockAll`,
        {
          ...batchParams,
        },
        { params: params },
      )
      .then(
        function() {
          if (batchParams.selectAll) {
            vm.table.rows.forEach(row => {
              row.locked = locked;
            });
          } else {
            const idSet = new Set(batchParams.invoiceIds);
            vm.table.rows.forEach(row => {
              if (idSet.has(row.id)) {
                row.locked = locked;
              }
            });
          }
          if (locked) {
            flySvc.success('msgDraftInvoicesLocked');
          } else {
            flySvc.success('msgDraftInvoicesUnlocked');
          }

          vm.loadingGlobalAction = false;
        },
        function(error) {
          vm.loadingGlobalAction = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
  };

  vm.downloadDraftInvoice = invoice => {
    $http
      .get(`${appUrls.api}/api/draftInvoice/PreviewPdf/${invoice.id}`, {
        responseType: 'arraybuffer',
      })
      .then(result => {
        const contentDisposition = result.headers('Content-Disposition');
        const filename = adminpulse.getFileNameFromHeader(contentDisposition);

        var blob = new Blob([result.data], { type: 'application/pdf' });
        if (blob) {
          FileSaver.saveAs(blob, filename);
        }
      });
  };

  vm.uploadAttachment = function(files, invoice) {
    if (!files || files.length < 1) return;

    var newAttachments = [];
    var formData = new FormData();
    formData.append('documentType', 1);
    formData.append('documentLinkType', 2);
    formData.append('linkId', invoice.id);
    formData.append('relationId', invoice.customer.id);

    files.forEach(function(file) {
      var attachment = {
        name: file.name,
        scanStatus: 1,
        invoiceId: invoice.id,
      };
      //Check if invoice details are loaded
      if (!!invoice.attachments) invoice.attachments.push(attachment);
      newAttachments.push(attachment);
      formData.append('data', file.data);
    });

    $http({
      method: 'POST',
      url: appUrls.documents + '/api/documents/',
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(file) {
            var attachment = newAttachments.find(function(el) {
              return el.name === file.name;
            });
            if (attachment) angular.extend(attachment, file);
          });
          if (
            !invoice.hasAttachment &&
            newAttachments.some(function(el) {
              return el.scanStatus === 2;
            })
          )
            vm.updateInvoice(invoice, true, 'hasAttachments');
        }
      })
      .catch(function(error) {
        if (!!invoice.attachments) {
          newAttachments.forEach(function(attachment) {
            var index = invoice.attachments.indexOf(attachment);
            invoice.attachments.splice(index, 1);
          });
        }
        flySvc.error(error);
        return '';
      });
  };

  vm.deleteAttachment = function(invoice, attachment) {
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteInvoiceAttachment').then(function() {
      $http
        .delete(appUrls.documents + '/api/documents/' + attachment.id)
        .then(function(response) {
          var result = response.data;
          var index = invoice.attachments.indexOf(attachment);
          invoice.attachments.splice(index, 1);
          if (invoice.attachments.length === 0) vm.updateInvoice(invoice, false, 'hasAttachments');
        })
        .catch(function(error) {
          flySvc.error(error);
          return '';
        });
    });
  };

  vm.downloadAttachment = attachment => DocumentService.download(attachment.id);

  vm.changeTransactionType = function(invoice) {
    invoice.transactionTypeActive = !invoice.transactionTypeActive;

    if (invoice.taxCategory !== invoice.customerTaxCategory)
      vm.updateInvoice(invoice, invoice.customerTaxCategory, 'taxCategory');

    if (invoice.taxExemptionReason !== invoice.customerTaxExemptionReason)
      vm.updateInvoice(invoice, invoice.customerTaxExemptionReason, 'taxExemptionReason');
  };

  vm.changeIsInvoice = function(invoice) {
    const isInvoice = !invoice.isInvoice;
    vm.updateInvoice(invoice, isInvoice, 'isInvoice');
  };

  var retrieveAttachments = function(invoice) {
    $http
      .get(appUrls.documents + '/api/documents/links/' + invoice.id + '/2/1')
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(attachment) {
            invoice.attachments.push(attachment);
          });
        }
      })
      .catch(function(error) {
        showError(error);
      });
  };

  vm.toggleDetails = function(invoice, expandDetails) {
    if (
      (invoice.loadingDetails &&
        detailRequests[invoice.id] &&
        detailRequests[invoice.id].$cancelRequest) ||
      invoice.isRemoving
    ) {
      detailRequests[invoice.id].$cancelRequest();
      invoice.loadingDetails = false;
      return;
    }

    if (
      !invoice.showDetails &&
      (!invoice.isLoaded() || (!!expandDetails && !invoice.detailsLoaded))
    ) {
      invoice.loadingDetails = true;
      detailRequests[invoice.id] = invoiceLineResource.query(
        {
          id: invoice.id,
          full: !!expandDetails,
        },
        function(data) {
          invoice.invoiceLines = data;
          invoice.showDetails = true;
          invoice.loadingDetails = false;
          invoice.attachments = [];
          invoice.detailsLoaded = !!expandDetails;
          if (invoice.hasAttachments) retrieveAttachments(invoice);
          if (typeof expandDetails !== 'undefined') {
            invoice.invoiceLines.forEach(line => {
              line.showDetails = !!expandDetails;
              line.showRelation =
                line.registrations &&
                line.registrations.some(r => r.invoiceStreamId !== invoice.invoiceStreamId);
            });
          }
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          invoice.loadingDetails = false;
        },
      );
    } else {
      invoice.showDetails = !invoice.showDetails;
      if (typeof expandDetails !== 'undefined') {
        invoice.invoiceLines.forEach(line => (line.showDetails = !!expandDetails));
      }
    }
  };

  vm.deleteInvoiceRequest = function(invoice, neverInvoice, neverSettleAdvances = false) {
    return draftInvoiceResource.remove(
      {
        id: invoice.id,
        neverInvoice: !!neverInvoice,
        neverSettleAdvances: !!neverSettleAdvances,
      },
      function() {
        flySvc.success($filter('translate')('Invoice removed'));

        if (vm.table) {
          for (var t = 0; t < vm.table.rows.length; t++) {
            if (vm.table.rows[t].id === invoice.id) {
              vm.table.rows.splice(t, 1);
              break;
            }
          }
          vm.reloadKPIs();
        }

        invoicingSvc.reloadBillableRelations();
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.deleteInvoice = function(invoice) {
    if (!invoice.isLoaded()) {
      //If invoice type is settlement, show never settle advance button
      if (invoice.invoiceType === 3) {
        return invoiceDialogsSvc
          .deleteWithNeverInvoice('comfirmUndoInvoice', null, [
            {
              message: 'neverSettleAdvancesAndNeverInvoiceRegistrations',
              value: { neverInvoice: true, neverSettleAdvances: true },
            },
          ])
          .then(function(result) {
            if (typeof result === 'object') {
              const { neverInvoice = false, neverSettleAdvances = false } = result;
              return vm.deleteInvoiceRequest(invoice, neverInvoice, neverSettleAdvances);
            } else {
              return vm.deleteInvoiceRequest(invoice, !!result, false);
            }
          });
      }
      //Show only never invoice reg button
      return invoiceDialogsSvc
        .deleteWithNeverInvoice('comfirmUndoInvoice')
        .then(function(neverInvoice) {
          return vm.deleteInvoiceRequest(invoice, !!neverInvoice, false);
        });
    }
    //Invoice is loaded so we can fine tune buttons

    const hasRegistrations = invoice.hasRegistrations();
    const hasSettledAdvances = invoice.hasLineType(6);
    if (!hasRegistrations && !hasSettledAdvances) {
      //Probably a free invoice, show delete dialog
      return dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteInvoice').then(function() {
        vm.deleteInvoiceRequest(invoice, false);
      });
    }

    if (hasRegistrations && hasSettledAdvances) {
      //Show dialog with extra button for advances
      return invoiceDialogsSvc
        .deleteWithNeverInvoice('comfirmUndoInvoice', null, [
          {
            message: 'neverSettleAdvancesAndNeverInvoiceRegistrations',
            value: { neverInvoice: true, neverSettleAdvances: true },
          },
        ])
        .then(function(result) {
          if (typeof result === 'object') {
            const { neverInvoice = false, neverSettleAdvances = false } = result;
            return vm.deleteInvoiceRequest(invoice, neverInvoice, neverSettleAdvances);
          } else {
            return vm.deleteInvoiceRequest(invoice, !!result, false);
          }
        });
    }

    if (hasRegistrations) {
      //Show only never invoice reg button
      return invoiceDialogsSvc
        .deleteWithNeverInvoice('comfirmUndoInvoice')
        .then(function(neverInvoice) {
          return vm.deleteInvoiceRequest(invoice, !!neverInvoice, false);
        });
    }

    if (hasSettledAdvances) {
      //Show never settle instead of never invoice reg button
      return invoiceDialogsSvc
        .deleteWithNeverInvoice('comfirmUndoInvoice', 'neverSettleAdvance')
        .then(function(neverSettleAdvances) {
          return vm.deleteInvoiceRequest(invoice, false, neverSettleAdvances);
        });
    }
  };

  vm.updateInvoice = function(invoice, value, prop) {
    if (!invoice || value === undefined || invoice[prop] === value) return false;
    if (prop === 'discountAmount') {
      if (invoice.discountType === 0) {
        if (Math.abs(value) > 1) {
          flySvc.error(10015, ['0', '100']);
          return '';
        } else if (value < 0) flySvc.message('msgNegativeDiscountWarning');
      }
    }

    if (
      prop === 'dateToNumber' &&
      value &&
      !invoice.canSend &&
      dataCache.getDefaultCompany().autoSendInvoices
    ) {
      flySvc.action('', 'msgCannotSendNoRelationEmail', 'relations.detail', 'btnOpenRelation');
    }

    var model = angular.copy(invoice);
    model[prop] = value;
    if (prop === 'discountType') {
      if (
        (invoice.discountType === 0 && value !== 0) ||
        (invoice.discountType !== 0 && value === 0)
      ) {
        model.discountAmount = 0;
      }
    }

    invoice.updating = true;

    return draftInvoiceResource.update({}, model).$promise.then(
      function(data) {
        invoice.updating = false;
        delete data.invoiceLines;
        angular.extend(invoice, data);
        if (invoice.invoiceErrors) {
          for (var i = 0; i < invoice.invoiceErrors.length; i++) {
            if (invoice.invoiceErrors[i].code === 11037)
              flySvc.error(invoice.invoiceErrors[i].code, invoice.invoiceErrors[i].parameters);
          }
        }

        const dateToNumber = moment.utc(invoice.dateToNumber).startOf('day');
        const currentDate = moment.utc().startOf('day');

        if (dateToNumber.isBefore(currentDate)) {
          var idx = vm.table.rows.findIndex(function(el) {
            return el.id === invoice.id;
          });
          if (idx >= 0) vm.table.rows.splice(idx, 1);

          flySvc.success('msgInvoiceProcessed', {
            name: $filter('relationName')(invoice.customer),
          });
          vm.reloadKPIs();
        } else if (dateToNumber.isSame(currentDate)) {
          flySvc.success('msgInvoiceWillBeProcessedTonight', {
            date: moment
              .utc()
              .startOf('day')
              .format('DD/MM/YYYY'),
          });
        }
        return false;
      },
      function(error) {
        invoice.updating = false;
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };
  vm.gotoInvoice = function(invoiceId, expand = false) {
    if (!invoiceId || !vm.table?.rows) return;
    var idx = vm.table.rows.findIndex(function(el) {
      return el.id === invoiceId;
    });
    if (idx < 0) return;
    vm.toggleDetails(vm.table.rows[idx], expand);
    $anchorScroll(`DraftInvoice-${invoiceId}`);
  };
  vm.reloadInvoice = function(id) {
    if (!id) return;
    return draftInvoiceResource.get({ id }).$promise.then(function(invoice) {
      var idx = vm.table.rows.findIndex(function(el) {
        return el.id === invoice.id;
      });
      invoice.invoiceLines = null;
      invoice.loadingDetails = false;

      if (idx >= 0) {
        if (vm.table.rows[idx].showDetails) {
          invoice.showDetails = false;
          angular.extend(vm.table.rows[idx], invoice);
          vm.toggleDetails(vm.table.rows[idx]);
        } else {
          angular.extend(vm.table.rows[idx], invoice);
        }
      } else {
        invoice.selected = vm.selectAll;
        invoice.discountActive = invoice.discountAmount > 0;
        invoice.transactionTypeActive = invoice.taxCategory !== invoice.customerTaxCategory;

        vm.table.rows.unshift(invoice);
      }
    });
  };

  vm.finalizeInvoice = function(invoice, sendMail) {
    if (!invoice || !invoice.id) return null;

    const doFinalizeInvoice = sendViaPeppol => {
      if (sendMail) {
        invoice.sending = true;
      } else {
        invoice.numbering = true;
      }

      return resourceFactorySvc.get('invoice').number(
        {
          sendMail: sendMail,
          sendViaPeppol: sendViaPeppol,
        },
        [invoice.id],
        function(result) {
          invoice.sending = false;
          invoice.numbering = false;

          if (result && result.hasOwnProperty(invoice.id)) {
            invoice.error = result[invoice.id];
          } else {
            if (vm.table) {
              for (var t = 0; t < vm.table.rows.length; t++) {
                if (vm.table.rows[t].id === invoice.id) {
                  vm.table.rows.splice(t, 1);
                  break;
                }
              }
              vm.reloadKPIs();
            }

            flySvc.success('msgInvoiceProcessed', {
              name: $filter('relationName')(invoice.customer),
            });
          }
        },
        function(error) {
          invoice.sending = false;
          invoice.numbering = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      ).$promise;
    };

    if (invoice.totalExclusive > 0 && !invoice.isInvoice) {
      return dialogsSvc
        .showYesNo('comfirmTitle', 'confirmFinalizePositiveCreditNote')
        .then(function() {
          return doFinalizeInvoice();
        });
    }

    if (invoice.totalExclusive < 0 && invoice.isInvoice) {
      return dialogsSvc
        .showYesNo('comfirmTitle', 'confirmFinalizeNegativeInvoice')
        .then(function() {
          return doFinalizeInvoice();
        });
    }

    return doFinalizeInvoice();
  };

  vm.fixErrors = function(invoice) {
    if (invoice.companyErrors.length) {
      if (
        invoice.companyErrors.length &&
        (invoice.companyErrors[0].code === 1043 ||
          invoice.companyErrors[0].code === 1044 ||
          invoice.companyErrors[0].code === 1045)
      ) {
        $state.go('settings.invoicetemplates');
      } else {
        $state.go('settings.company', { companyId: invoice.companyId });
      }
    } else if (invoice.relationErrors.length) {
      $state.go('relations.detail', {
        relId: invoice.customer.id,
      });
    }
  };

  vm.preview = function(invoice) {
    invoiceDialogsSvc.previewDraftInvoice(invoice, vm.finalizeInvoice);
  };

  vm.hasFilters = function() {
    if (vm.table && vm.table.tableInfo && !angular.equals(vm.table.tableInfo.filters, {}))
      return true;
    return !angular.equals(vm.filters, emptyFilters);
  };
  vm.toggleAdvanceFilters = function() {
    vm.showAdvanceFilters = !vm.showAdvanceFilters;
    const params = JSON.parse(sessionStorage.getItem('DraftInvoiceOverviewParams')) || {};

    sessionStorage.setItem(
      'DraftInvoiceOverviewParams',
      JSON.stringify({
        ...params,
        showAdvanceFilters: vm.showAdvanceFilters,
      }),
    );
  };
  vm.selectAllChanged = function() {
    if (!vm.table || !vm.table.rows) return;
    angular.forEach(vm.table.rows, function(el) {
      el.selected = vm.selectAll;
    });
  };

  vm.selectedCount = function(canNumber = false) {
    if (!vm.table || !vm.table.rows) return 0;
    const total = (vm.dashboard && vm.dashboard.totalInvoices) || 0;
    const count = vm.table.rows.reduce(
      (cnt, inv) =>
        cnt + (vm.selectAll !== (inv.selected && (!canNumber || inv.canNumber(true))) ? 1 : 0),
      0,
    );

    return vm.selectAll ? total - count : count;
  };

  vm.getErrorMsg = flySvc.getErrorMsg;

  vm.getBookyearInfo = function(invoice) {
    if (!vm.bookyearInfo) return null;
    return vm.bookyearInfo[invoice.companyId];
  };
  vm.getPreviousBookyear = function(invoice) {
    const info = vm.getBookyearInfo(invoice);
    if (!info) return null;
    return invoice.isInvoice
      ? info.lastInvoiceDatePreviousBookyear
      : info.lastCreditnoteDatePreviousBookyear;
  };
  vm.getCurrentBookyear = function(invoice) {
    const info = vm.getBookyearInfo(invoice);
    if (!info) return null;
    return invoice.isInvoice
      ? info.lastInvoiceDateCurrentBookyear
      : info.lastCreditnoteDateCurrentBookyear;
  };

  vm.getBatchSelectionParams = function(canNumber = false) {
    return {
      selectAll: vm.selectAll,
      invoiceIds:
        vm.table && vm.table.rows
          ? vm.table.rows
              .filter(inv => vm.selectAll !== (inv.selected && (!canNumber || inv.canNumber(true))))
              .map(inv => inv.id)
          : [],
    };
  };

  vm.createInvoiceReport = function() {
    vm.creatingReport = true;

    const requestQueryParams = {
      ...vm.currentSearchParams,
      culture: $translate.use(),
      connectionId: SignalRService.getConnectionId(),
    };

    const requestBody = vm.getBatchSelectionParams();

    return draftInvoiceResource.report(requestQueryParams, requestBody).$promise.then(
      function() {
        vm.creatingReport = false;

        flySvc.success('ExportToExcelStarted');
      },
      function(error) {
        vm.creatingReport = false;
        showError(error);
      },
    );
  };
  vm.exportRegistrations = invoice => {
    const filters = {
      [invoice.invoiceType === 6 ? 'intraCompanyInvoiceId' : 'invoiceId']: invoice.id,
      from: null,
      to: null,
    };

    return registrationService
      .createReport(filters, null, null, guid.empty)
      .$promise.then(function() {
        flySvc.success('ExportToExcelStarted');
      }, showError);
  };

  vm.canExportRegistrations = invoice => {
    if (!invoice) return false;
    if (invoice.invoiceType === 2) return false; //Advance
    if (invoice.invoiceType === 5) return false; //Free
    if (invoice.isLoaded()) return invoice.hasRegistrations(); //If the lines are loaded, check if there are registrations
    return true;
  };
  vm.showInvoicingHistory = function(invoice) {
    return invoiceDialogsSvc.showInvoicingHistory(
      invoice.invoiceStreamId,
      invoice,
      invoice.customer.id,
    );
  };
  vm.showInvoiceAudit = function(invoice) {
    invoiceDialogsSvc.invoiceAudit(invoice);
  };

  vm.showMergeDialog = function(invoice) {
    return invoiceDialogsSvc.merge(invoice).then(function(success) {
      if (success) {
        vm.table.reload();
      }
    });
  };
  const getBillingInformationStreamId = invoice =>
    invoice.invoiceStreamId || (invoice.invoiceStream && invoice.invoiceStream.id);

  vm.getRelationBillingInformation = invoice => {
    const info = vm.billingInformation[invoice.customer.id];
    return info ? info.relationBillingInformation : null;
  };

  vm.getInvoiceStreamBillingInformation = invoice => {
    const info = vm.billingInformation[invoice.customer.id];
    const streamId = getBillingInformationStreamId(invoice);
    if (!info || !info.invoiceStreamBillingInformation || !streamId) return null;
    return info.invoiceStreamBillingInformation[streamId];
  };

  const hasBillingInformationText = invoice =>
    !!vm.getRelationBillingInformation(invoice) || !!vm.getInvoiceStreamBillingInformation(invoice);

  vm.getBillingInformation = invoice => {
    if (!invoice.hasBillingInformation) return;
    const relationId = invoice.customer.id;
    if (typeof vm.billingInformation[relationId] !== 'undefined') {
      invoice.showBillingInformation = hasBillingInformationText(invoice);
      return vm.billingInformation[relationId];
    }
    vm.billingInformation[relationId] = null;
    return $http
      .get(`${appUrls.api}/api/Relation/BillingInformation/${relationId}`)
      .then(({ data }) => {
        vm.billingInformation[relationId] = data;
        if (invoice.showBillingInformation !== false) {
          invoice.showBillingInformation = hasBillingInformationText(invoice);
        }
        return data;
      }, showError);
  };
  vm.hideBillingInformation = invoice => {
    invoice.showBillingInformation = false;
  };
  vm.updateReferenceYear = (invoice, referenceYear) => {
    if (!invoice || typeof referenceYear === 'undefined') return;
    if (invoice.referenceYear === referenceYear) return;

    return $http
      .post(`${appUrls.api}/api/draftinvoice/ReferenceYear`, null, {
        params: {
          id: invoice.id,
          year: referenceYear,
        },
      })
      .then(
        function() {
          flySvc.success();
          return true;
        },
        function(error) {
          flySvc.error(error);
          return '';
        },
      );
  };

  vm.writeOffInternally = invoice => {
    return invoiceDialogsSvc.writeOffInternally(invoice).then(function(success) {
      if (success) {
        if (!vm.table || !vm.table.rows) return;
        var idx = vm.table.rows.findIndex(x => x.id === invoice.id);
        if (idx >= 0) vm.table.rows.splice(idx, 1);
      }
    });
  };
  vm.batchWriteOffInternally = () => {
    if (vm.selectedCount(false) === 0) return;
    var params = { ...vm.currentSearchParams };
    const batchParams = vm.getBatchSelectionParams(false);

    return invoiceDialogsSvc.batchWriteOffInternally(params, batchParams).then(function(success) {
      if (success) {
        if (!vm.table || !vm.table.rows) return;
        vm.table.reload();
      }
    });
  };

  const draftInvoiceRemovedHandler = invoiceId => {
    if (!vm.table || !vm.table.rows) return;
    $timeout(function() {
      var idx = vm.table.rows.findIndex(x => x.id === invoiceId);
      if (idx >= 0) vm.table.rows.splice(idx, 1);
    }, 0);
  };
  const refreshProcessingInvoices = () => {
    $timeout(() => invoicingSvc.reloadProcessingInvoicesInfo(), 0);
  };

  SignalRService.subscribe('draftInvoiceRemoved', draftInvoiceRemovedHandler);
  SignalRService.subscribe('refreshProcessingInvoices', refreshProcessingInvoices);

  $scope.$on('$destroy', function() {
    SignalRService.unsubscribe('draftInvoiceRemoved', draftInvoiceRemovedHandler);
    SignalRService.unsubscribe('refreshProcessingInvoices', refreshProcessingInvoices);
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();
    if (vm.kpiRequest && vm.kpiRequest.$cancelRequest) vm.kpiRequest.$cancelRequest();
    if (bookyearInfoRequest && bookyearInfoRequest.$cancelRequest)
      bookyearInfoRequest.$cancelRequest();
  });
  if (vm.initFilters) {
    vm.initFilters = false;
    if (!initStateParams()) {
      setParamsFromSessionStorage();
    }
    if (vm.filters.relationId && !vm.customer) {
      initCustomer(vm.filters.relationId);
    }
  }
}
